import { RouteObject } from "react-router-dom";
import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";

const DiasFileDetails = lazyWithReload(
  () => import("src/admin/features/DiasFileDetails/DiasFileDetails"),
);
const DiasFiles = lazyWithReload(
  () => import("src/admin/features/DiasFiles/DiasFiles"),
);
const PaymentDetails = lazyWithReload(
  () => import("src/admin/features/PaymentDetails/PaymentDetails"),
);
const PaymentSums = lazyWithReload(
  () => import("src/admin/features/PaymentSums/PaymentsSums"),
);
const ChamberDetails = lazyWithReload(
  () => import("src/cashier/features/chamberDetails/ChamberDetails"),
);
const CashierDashboard = lazyWithReload(
  () => import("src/cashier/features/dashboard/CashierDashboard"),
);
const NewRemittance = lazyWithReload(
  () => import("src/cashier/features/newRemittance/NewRemittance"),
);
const RemittanceFiles = lazyWithReload(
  () => import("src/cashier/features/remittanceFiles/RemittanceFiles"),
);
const RemittancesFileDetails = lazyWithReload(
  () =>
    import(
      "src/cashier/features/remittancesFileDetails/RemittancesFileDetails"
    ),
);
const ThreeMonthsReport = lazyWithReload(
  () => import("src/cashier/features/threeMonthsReport/ThreeMonthsReport"),
);
import RouteProtector from "./RouteProtector";

export const cashierPaths: RouteObject = {
  path: "cashier",
  children: [
    {
      path: "dashboard",
      element: (
        <RouteProtector allowedUsers={["isCashier"]}>
          <CashierDashboard />
        </RouteProtector>
      ),
    },
    {
      path: "newRemittance",
      element: (
        <RouteProtector allowedUsers={["isCashier"]}>
          <NewRemittance />
        </RouteProtector>
      ),
    },
    {
      path: "remittancesFiles",
      element: (
        <RouteProtector allowedUsers={["isCashier"]}>
          <RemittanceFiles />
        </RouteProtector>
      ),
    },
    {
      path: "remittancesFileDetails/:p04Id",
      element: (
        <RouteProtector allowedUsers={["isCashier"]}>
          <RemittancesFileDetails />
        </RouteProtector>
      ),
    },
    {
      path: "chamberDetails",
      element: (
        <RouteProtector allowedUsers={["isCashier"]}>
          <ChamberDetails />
        </RouteProtector>
      ),
    },
    {
      path: "threeMonthReport",
      element: (
        <RouteProtector allowedUsers={["isCashier"]}>
          <ThreeMonthsReport />
        </RouteProtector>
      ),
    },
    {
      path: "paymentSums",
      element: (
        <RouteProtector allowedUsers={["isCashier"]}>
          <PaymentSums />
        </RouteProtector>
      ),
    },
    {
      path: "paymentDetails",
      element: (
        <RouteProtector allowedUsers={["isCashier"]}>
          <PaymentDetails />
        </RouteProtector>
      ),
    },
    {
      path: "diasFiles",
      element: (
        <RouteProtector allowedUsers={["isCashier"]}>
          <DiasFiles />
        </RouteProtector>
      ),
    },
    {
      path: "diasFileDetails/:fileId",
      element: (
        <RouteProtector allowedUsers={["isCashier"]}>
          <DiasFileDetails />
        </RouteProtector>
      ),
    },
  ],
};
